import { Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AbstractControlWarn } from 'src/app/auth/interfaces/abstract-control-warn.interface';
import { IUserExistsResponse } from 'src/app/auth/interfaces/user-exists-reponse.interface';
import { AnalyticsEvent, AnalyticsService } from 'src/app/core/services/analytics-service';
import { AuthApiService } from 'src/app/shared/services/auth/auth.api.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private authApi: AuthApiService, private analyticsService: AnalyticsService) {
  }

  public createEmailValidator(): (control: AbstractControlWarn) => Observable<{ userNotExist: boolean }
    | { tooManyRequests: boolean }> | Promise<{ userNotExist: boolean } | { tooManyRequests: boolean }> {
    return (control: AbstractControlWarn) =>
      timer(500).pipe(
        switchMap(() => this.authApi.userExists(control.value)),
        map(({ userExists }: IUserExistsResponse) => {
          if (userExists === 'unknown') {
            control.warnings = { ...control.warnings, userUnknown: true };
          }
          return !!userExists ? null : { userNotExist: true };
        }),
        catchError(() => of({ tooManyRequests: true })),
      );
  }

  public trackLoginEvents(email: string): void {
    this.analyticsService.trackEvent(
      new AnalyticsEvent('login cardClicked', {
        description: 'login cardClicked',
        email,
      }),
    );

    this.analyticsService.trackWpEventIfEnabled('Login');
  }
}
